import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon, ShoppingBagIcon, Trash2Icon, XIcon } from 'lucide-react';
import { formatPrice, useCart } from '../contexts/CartContext';
export function CartDrawer() {
  const {
    lines,
    total,
    isOpen,
    close,
    remove,
    setQuantity
  } = useCart();
  return <AnimatePresence data-id="element-18" data-mp="2cdfdmyi5xvkj">
      {isOpen && <div className="fixed inset-0 z-50" role="dialog" aria-modal="true" aria-label="Panier" data-id="element-19" data-mp="2cegz7wwt20gi">
          <motion.div className="absolute inset-0 bg-ink/40" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} onClick={close} data-id="element-20" data-mp="304kv1i3r4vwy" />
          <motion.aside className="absolute right-0 top-0 flex h-full w-full max-w-md flex-col bg-cream shadow-xl" initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-21" data-mp="2v9fc8s5nbxd3">
            <div className="flex items-center justify-between border-b border-line px-6 py-5" data-id="element-22" data-mp="40bpp9fgpq9p">
              <h2 className="font-display text-lg text-ink" data-id="element-23" data-mp="3v760hyzyy93z">Votre panier</h2>
              <button type="button" onClick={close} className="rounded-full p-2 text-muted transition-colors duration-150 ease-soft hover:bg-parchment hover:text-ink" aria-label="Fermer le panier" data-id="element-24" data-mp="cwavmqj6rzle">
                <XIcon className="h-5 w-5" data-id="element-25" data-mp="htazcuskcq9c" />
              </button>
            </div>

            {lines.length === 0 ? <div className="flex flex-1 flex-col items-center justify-center gap-3 px-8 text-center" data-id="element-26" data-mp="vt2jzedl54wb">
                <ShoppingBagIcon className="h-8 w-8 text-line" aria-hidden="true" data-id="element-27" data-mp="rq5xhckxcon3" />
                <p className="font-display text-lg text-ink" data-id="element-28" data-mp="2xlqpjudpc4f9">Votre panier est vide</p>
                <p className="text-sm text-muted" data-id="element-29" data-mp="2tkygp28qs1ji">
                  Laine filée, tricots mohair et savons de la ferme vous attendent en boutique.
                </p>
              </div> : <ul className="flex-1 divide-y divide-line overflow-y-auto px-6" data-id="element-30" data-mp="11im2eqxmkab1">
                {lines.map(line => <li key={line.product.id} className="flex gap-4 py-5" data-id="element-31" data-mp="16j9r35ydsf23">
                    <img src={line.product.image} alt="" className="h-20 w-20 shrink-0 rounded-md object-cover" data-id="element-32" data-mp="1bh1lc6mi0d9g" />
                    <div className="flex min-w-0 flex-1 flex-col" data-id="element-33" data-mp="1kfn6m9jcu6dx">
                      <p className="truncate text-sm font-medium text-ink" data-id="element-34" data-mp="1p751cfusbaqg">{line.product.name}</p>
                      <p className="mt-0.5 text-xs text-muted" data-id="element-35" data-mp="1u7atdx4yuz92">{line.product.unit}</p>
                      <div className="mt-auto flex items-center justify-between pt-3" data-id="element-36" data-mp="1z64b61radcf1">
                        <div className="flex items-center rounded-full border border-line" data-id="element-37" data-mp="237fqnegg4h9i">
                          <button type="button" className="p-1.5 text-muted hover:text-ink" onClick={() => setQuantity(line.product.id, line.quantity - 1)} aria-label="Retirer un exemplaire" data-id="element-38" data-mp="2353932elo8wz">
                            <MinusIcon className="h-3.5 w-3.5" data-id="element-39" data-mp="39qiit1fxm5i3" />
                          </button>
                          <span className="w-6 text-center text-sm tabular-nums" data-id="element-40" data-mp="b8cxfdn4c3jq">{line.quantity}</span>
                          <button type="button" className="p-1.5 text-muted hover:text-ink" onClick={() => setQuantity(line.product.id, line.quantity + 1)} aria-label="Ajouter un exemplaire" data-id="element-41" data-mp="68qlr8mxuvd1">
                            <PlusIcon className="h-3.5 w-3.5" data-id="element-42" data-mp="u05pn5ud5kqe" />
                          </button>
                        </div>
                        <div className="flex items-center gap-3" data-id="element-43" data-mp="p61gqh1jf2mo">
                          <span className="text-sm font-medium tabular-nums text-ink" data-id="element-44" data-mp="9o9z8jfq7u0p">
                            {formatPrice(line.product.price * line.quantity)}
                          </span>
                          <button type="button" onClick={() => remove(line.product.id)} className="text-muted transition-colors duration-150 ease-soft hover:text-clay" aria-label={`Supprimer ${line.product.name}`} data-id="element-45" data-mp="3vym9klbxr0og">
                            <Trash2Icon className="h-4 w-4" data-id="element-46" data-mp="iqt2h4nfc8nh" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </li>)}
              </ul>}

            {lines.length > 0 && <div className="border-t border-line px-6 py-5" data-id="element-47" data-mp="1g5x4at7aizrm">
                <div className="flex items-baseline justify-between" data-id="element-48" data-mp="1g786iol37zgm">
                  <span className="text-sm text-muted" data-id="element-49" data-mp="30vambw23r6w9">Sous-total</span>
                  <span className="font-display text-xl text-ink tabular-nums" data-id="element-50" data-mp="2vxheyzp2c6ue">{formatPrice(total)}</span>
                </div>
                <p className="mt-1 text-xs text-muted" data-id="element-51" data-mp="39nkvrb56b8cg">Livraison calculée à l’étape suivante.</p>
                <button type="button" className="mt-4 w-full rounded-full bg-olive py-3 text-sm font-medium text-cream transition-colors duration-150 ease-soft hover:bg-olive-dark" data-id="element-52" data-mp="35o3qoitnsd7t">
                  Passer commande
                </button>
              </div>}
          </motion.aside>
        </div>}
    </AnimatePresence>;
}